<template lang="pug">
dv-autocomplete(
  v-bind="attrs"
  v-on="listeners"
  :items="addresses"
  :loading="isLoading"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import debounce from 'lodash/debounce';
import { PER_PAGE } from '@/constants/pagination';
import DvAutocomplete from '@/packages/ui/components/inputs/DvAutocomplete.vue';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'AddressInput',
  components: {
    DvAutocomplete,
  },
  props: {},
  data() {
    return {
      addresses: [],
      isLoading: false,
    };
  },
  computed: {
    attrs() {
      return {
        itemText: 'value',
        itemValue: 'value',
        ...this.$attrs,
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        'update:search-input': this.onUpdateSearchInput,
      };
    },
  },
  watch: {},
  created() {
    this.debouncedGetAddresses = debounce(this.getAddresses, DEBOUNCE_DELAY);
  },
  methods: {
    getAddresses(query) {
      this.isLoading = true;

      const payload = {
        query,
        count: PER_PAGE.twenty,
      };

      this.$api.dadata
        .suggestAddress(payload)
        .then((response) => {
          this.addresses = response.data.suggestions;
        })
        .catch(() => {
          this.$toast.error('Произошла ошибка при попытке получить данные');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onUpdateSearchInput(value) {
      this.debouncedGetAddresses(value);

      this.$emit('update:search-input', value);
    },
  },
};
</script>
